import React, { useState } from 'react';
import Welcome from './Welcome';
import ContactInfo from './ContactInfo';
import TrainingHistory from './TrainingHistory';
import FirstResponder from './FirstResponder';
import TrainingFrequency from './TrainingFrequency';
import TrainingGoal from './TrainingGoal';
import WeightliftingExperience from './WeightliftingExperience';
import WeightliftingStats from './WeightliftingStats';
import Results from './Results';
// const DEV_API = 'http://localhost:80/program-recommendation/';
const PROD_API = 'https://safe-headland-32280.herokuapp.com/program-recommendation/';

function RecommendationForm() {
  let [pageIdx, setPageIdx] = useState(0);
  let [formData, setFormData] = useState({
    name: '',
    email: '',
    trainingHistory: [],
    firstResponder: '',
    trainingFrequency: '',
    trainingGoal: '',
    weightliftingStats: {
      technique: 0,
      beenCoached: '',
      experience: '',
      units: 'kg',
      snatch: '',
      cleanJerk: '',
      gender: 'm',
      age: '',
      bw: ''
    }
  });
  let [results, setResults] = useState([]);

  function nextPage() {
    return setPageIdx(prev => prev + 1);
  }

  function prevPage() {
    return setPageIdx(prev => prev - 1);
  }

  async function calculateResults(data) {
    return fetch(PROD_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(result => setResults(result))
    .catch(error => console.error('Error @calculateResults() fetch():', error));
  }

  switch (pageIdx) {
    case 0:
      return (
        <Welcome
          nextPage={nextPage}
        />
      );
    case 1:
      return (
        <TrainingHistory
          formData={formData}
          setFormData={setFormData}
          nextPage={nextPage}
          prevPage={prevPage}
        />
      );
    case 2:
      return (
        <FirstResponder
          formData={formData}
          setFormData={setFormData}
          nextPage={nextPage}
          prevPage={prevPage}
        />
      );
    case 3:
      return (
        <TrainingFrequency
          formData={formData}
          setFormData={setFormData}
          nextPage={nextPage}
          prevPage={prevPage}
        />
      );
    case 4:
      return (
        <TrainingGoal
          formData={formData}
          setFormData={setFormData}
          nextPage={nextPage}
          prevPage={prevPage}
          goToContact={() => setPageIdx(7)}
        />
      );
    case 5:
      return (
        <WeightliftingExperience
          formData={formData}
          setFormData={setFormData}
          nextPage={nextPage}
          prevPage={prevPage}
          goToContact={() => setPageIdx(7)}
        />
      );
    case 6:
      return (
        <WeightliftingStats
          formData={formData}
          setFormData={setFormData}
          nextPage={nextPage}
          prevPage={prevPage}
        />
      );
    case 7:
      return (
        <ContactInfo
          formData={formData}
          setFormData={setFormData}
          calculateResults={calculateResults}
          goToResults={() => setPageIdx(8)}
        />
      );
    default:
      return (
        <Results
          formData={formData}
          results={results}
        />
      );
  }
}

export default RecommendationForm;